import React, { Component, Suspense, lazy } from 'react'
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import { withWidth } from '@material-ui/core';
import Loader from '../../../helpers/loader-full';
import HUBContext from '../../../services/HUBContext';
import { Switch, Redirect, withRouter } from 'react-router-dom';
import { PrivateRoute } from '../../../components';
import { FormattedMessage } from 'react-intl';
import UploadFineForm from '../../../views/Fines/admin/UploadFineForm';

const NoCompanySelected = lazy(() => import('../../Dashboard/components/NoCompanySelected/noCompanySelected'));
const Analysis = lazy(() => import('../../../views/Analysis'));
const Dash = lazy(() => import('../../../views/Dash'));
const Depreciation = lazy(() => import('../../../views/Depreciation'));
const Association = lazy(() => import('../../../views/Association'));
const AlertEvent = lazy(() => import('../../../views/Alerts/alertEvents'));
const Alerts = lazy(() => import('../../../views/Alerts'));
const Goals = lazy(() => import('../../../views/Goals'));
const Users = lazy(() => import('../../../views/Users'));
const ListUsers = lazy(() => import('../../../views/Users/admin/listUsers'));
const NewUserForm = lazy(() => import('../../../views/Users/admin/newUserForm'));
const UserDetails = lazy(() => import('../../../views/Users/admin/userDetails'));
const EditUserForm = lazy(() => import('../../../views/Users/admin/editUserForm'));
const SetHierarchiesStep = lazy(() => import('../../../views/Users/admin/setHierarchiesStep'));
const SetCostCentersStep = lazy(() => import('../../../views/Users/admin/setCostCentersStep'));
const Hierarchy = lazy(() => import('../../../views/Hierarchy'));
const UploadData = lazy(() => import('../../../views/UploadData'));
const Integrators = lazy(() => import('../../../views/Integrators'));
const Account = lazy(() => import('../../../views/Account'));

//const DriversAdmin = lazy(() => import('../../../views/Drivers/admin/TabControl'))
const DriversAdmin = lazy(() => import('../../../views/Drivers/detail/TabControl'));
const DriversCRUD = lazy(() => import('../../../views/Drivers/admin/TabControl'));
const DriverUpload = lazy(() => import('../../../views/Drivers/admin/DriverUpload'));

//const VehiclesAdmin = lazy(() => import('../../../views/Vehicles/admin/TabControl'))
const VehiclesAdmin = lazy(() => import('../../../views/Vehicles/detail/TabControl'));
const VehicleDocumentsView = lazy(() => import('../../../views/Vehicles/detail/DocumentsView'));
const VehiclesCRUD = lazy(() => import('../../../views/Vehicles/admin/TabControl'));
const VehicleUpload = lazy(() => import('../../../views/Vehicles/admin/VehicleUpload'));

const FinesCRUD = lazy(() => import('../../../views/Fines/admin/TabControl'));
const NewFineForm = lazy(() => import('../../../views/Fines/admin/NewFineForm'));
const UploadHistory = lazy(() => import('../../../views/Fines/admin/UploadHistory'));
const UploadHistoryPRO = lazy(() => import('../../../views/Fines/admin/UploadHistoryPRO'));

const Pptx = lazy(() => import('../../../views/pptx'));
const PptxList = lazy(() => import('../../../views/pptx/lists'));
const TicketSGA = lazy(() => import('../../../views/TicketSGA/index'));
const GlobalSearch = lazy(() => import('../../../views/GlobalSearch'));
const Inventory = lazy(() => import('../../../views/Mfg/admin/inventory'));
const VehicleLog = lazy(() => import('../../../views/UploadSR/VehicleLog'));

const Invoices = lazy(() => import('../../../views/Invoices/index'));
const VehicleSingleRegistryUpload = lazy(() => import('../../../views/Vehicles/admin/VehicleSingleRegistryUpload'));
const VehicleSingleRegistryInsert = lazy(() => import('../../../views/Vehicles/admin/VehicleSingleRegistryInsert'));
const VehicleSingleRegistryUpdate = lazy(() => import('../../../views/Vehicles/admin/VehicleSingleRegistryUpdate'));
const VehicleSingleRegistrySyncHistoryPage = lazy(() => import('../../../views/Vehicles/admin/VehicleSingleRegistrySyncHistoryPage/VehicleSingleRegistrySyncHistoryPage'));

class DashboardSwitch extends Component {

    render() {
        const { match } = this.props

        return (
            <Suspense fallback={<Loader />}>
                <Switch>
                    <Redirect exact from={`${match.path}/:cid`} to={`${match.path}/:cid/dash`} />

                    <PrivateRoute exact path={match.path}><NoCompanySelected {...this.props} {...this.context} /></PrivateRoute>

                    <PrivateRoute exact component={Alerts} path={`${match.path}/:cid/alerts`} />
                    <PrivateRoute exact component={Alerts} path={`${match.path}/:cid/alerts/:id`} />
                    <PrivateRoute exact component={AlertEvent} path={`${match.path}/:cid/alertevents`} />
                    <PrivateRoute exact component={Goals} path={`${match.path}/:cid/goals`} />
                    {/*<PrivateRoute exact component={Users} path={`${match.path}/:cid/users`} />*/}
                    {/*<PrivateRoute exact component={Users} path={`${match.path}/:cid/users/:id`} />*/}
                    <PrivateRoute exact component={ListUsers} path={`${match.path}/:cid/users`} />
                    <PrivateRoute exact component={NewUserForm} path={`${match.path}/:cid/users/new`} />
                    <PrivateRoute exact component={UserDetails} path={`${match.path}/:cid/users/:id`} />
                    <PrivateRoute exact component={EditUserForm} path={`${match.path}/:cid/users/:id/edit`} />
                    <PrivateRoute exact component={SetHierarchiesStep} path={`${match.path}/:cid/users/:id/sethierarchies`} />
                    <PrivateRoute exact component={SetCostCentersStep} path={`${match.path}/:cid/users/:id/setcostcenters`} />

                    <PrivateRoute exact component={Account} path={`${match.path}/:cid/account`} />
                    <PrivateRoute exact component={Account} path={`${match.path}/:cid/account/:id`} />

                    <PrivateRoute exact component={Hierarchy} path={`${match.path}/:cid/hierarchies`} />

                    <PrivateRoute exact component={UploadData} path={`${match.path}/:cid/upload`} />
                    <PrivateRoute exact component={UploadData} path={`${match.path}/:cid/upload/:id`} />

                    <PrivateRoute exact component={Integrators} path={`${match.path}/:cid/integrators`} />

                    <PrivateRoute exact component={DriversAdmin} path={`${match.path}/:cid/driver/:id`} />
                    <PrivateRoute exact component={DriversAdmin} path={`${match.path}/:cid/driver/:id/:tab`} />
                    <PrivateRoute exact component={DriversCRUD} path={`${match.path}/:cid/driver/admin/:id/:tab`} />
                    <PrivateRoute exact component={DriverUpload} path={`${match.path}/:cid/driverupload`} />

                    <PrivateRoute exact component={VehiclesAdmin} path={`${match.path}/:cid/vehicle/details/:id`} />
                    <PrivateRoute exact component={VehiclesAdmin} path={`${match.path}/:cid/vehicle/details/:id/:tab`} />

                    <PrivateRoute exact component={VehicleSingleRegistryUpdate} path={`${match.path}/:cid/vehiclecrud/:id/:action/:tab`} />
                    <PrivateRoute exact component={VehicleSingleRegistryUpdate} path={`${match.path}/:cid/vehicle/admin/:id/:tab`} />
                    
                    <PrivateRoute exact component={VehicleSingleRegistryUpload} path={`${match.path}/:cid/vehicleupload`} />
                    <PrivateRoute exact component={VehicleSingleRegistryUpload} path={`${match.path}/:cid/vehicle/upload`} />
                    <PrivateRoute exact component={VehicleSingleRegistryInsert} path={`${match.path}/:cid/vehicle/insert`} />
                    <PrivateRoute exact component={VehicleSingleRegistryUpdate} path={`${match.path}/:cid/vehicle/update/:id`} />
                    <PrivateRoute exact component={VehicleSingleRegistrySyncHistoryPage} path={`${match.path}/:cid/vehicle/single-registry/sync-history`} />

                    <PrivateRoute exact component={VehicleDocumentsView} path={`${match.path}/:cid/vehicledocumentsview`} />

                    <PrivateRoute exact component={FinesCRUD} path={`${match.path}/:cid/fines/admin/:id/:tab`} />
                    <PrivateRoute exact component={NewFineForm} path={`${match.path}/:cid/fines/new`} />
                    <PrivateRoute exact component={UploadFineForm} path={`${match.path}/:cid/fines/upload`} />
                    <PrivateRoute exact component={UploadHistory} path={`${match.path}/:cid/fines/upload/history`} />
                    <PrivateRoute exact component={UploadHistoryPRO} path={`${match.path}/:cid/fines/upload/historyPro`} />

                    <PrivateRoute exact component={Analysis} path={`${match.path}/:cid/analysis`} />
                    <PrivateRoute exact component={Depreciation} path={`${match.path}/:cid/depreciation`} />

                    <PrivateRoute exact component={Association} path={`${match.path}/:cid/association`} />
                    <PrivateRoute exact component={Association} path={`${match.path}/:cid/association/:tab`} />

                    <PrivateRoute exact component={Dash} path={`${match.path}/:cid/dash`} />
                    <PrivateRoute exact component={Dash} path={`${match.path}/:cid/dash/:did`} />
                    <PrivateRoute exact component={Dash} path={`${match.path}/:cid/dash/:did/widget/:wid`} />
                    <PrivateRoute exact component={Dash} path={`${match.path}/:cid/dash/:did/widget/:wid/view/:view`} />
                    <PrivateRoute exact component={Dash} path={`${match.path}/:cid/dash/:did/:component`} />

                    <PrivateRoute exact component={PptxList} path={`${match.path}/:cid/pptx-list`} />
                    <PrivateRoute exact component={PptxList} path={`${match.path}/:cid/pptx-list/:id`} />
                    <PrivateRoute exact component={Pptx} path={`${match.path}/:cid/pptx`} />
                    <PrivateRoute exact component={Pptx} path={`${match.path}/:cid/pptx/:id`} />

                    <PrivateRoute exact component={TicketSGA} path={`${match.path}/:cid/ticketsga`} />
                    <PrivateRoute exact component={GlobalSearch} path={`${match.path}/:cid/search`} />
                    <PrivateRoute exact component={GlobalSearch} path={`${match.path}/:cid/search/:q`} />
                    <PrivateRoute exact component={Inventory} path={`${match.path}/:cid/mfg/inventory`} />

                    <PrivateRoute exact component={VehicleLog} path={`${match.path}/:cid/vehicleLog`} />

                    <PrivateRoute exact component={Invoices} path={`${match.path}/:cid/gohubinvoices`} />

                    <PrivateRoute><div><FormattedMessage id="componentNotFound" defaultMessage="Not found component" /></div></PrivateRoute>
                </Switch>
            </Suspense>
        );
    };
}

DashboardSwitch.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    width: PropTypes.string.isRequired,
};
DashboardSwitch.contextType = HUBContext;
DashboardSwitch = withRouter(DashboardSwitch);
export default compose(withWidth())(DashboardSwitch);